export const headCells = [
  //for zero(0) index for Compliance Category
  [{
    id: 'id',
    label: 'Id',
    sortable: false,
    align: 'left',
    numIndex: 0,
    width: "2%",
    activeIndexOnly: true,
  },
  {
    id: 'title',
    label: 'Title',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: "30%",
    activeIndexOnly: true,
  },
  {
    id: 'is_active',
    label: 'Status',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: "10%",
    activeIndexOnly: true,
  }, {
    id: 'timesheet_name',
    label: 'Created By',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: "20%",
    activeIndexOnly: true,
  }, {
    id: 'timesheet_name',
    label: 'Created Date',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: "20%",
    activeIndexOnly: true,
  },
  {
    id: 'action',
    label: 'Action',
    sortable: false,
    align: 'center',
    numIndex: 0,
    width: "30%",
    activeIndexOnly: true,
  },],


]
